import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57f7dc0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "additional-documents-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line1" }, "Additional Documents")
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Max 100MB per file"),
  /*#__PURE__*/_createTextVNode(", "),
  /*#__PURE__*/_createElementVNode("small", null, "5 files max")
], -1))
const _hoisted_5 = { class: "ls-table mt-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "File name"),
    /*#__PURE__*/_createElementVNode("th", null, "Date uploaded"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_7 = ["title"]
const _hoisted_8 = { style: {"display":"block","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_9 = { style: {"width":"160px"} }
const _hoisted_10 = { style: {"width":"200px"} }
const _hoisted_11 = ["disabled", "onClick"]
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  colspan: 3
}
const _hoisted_15 = {
  key: 1,
  colspan: 3
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "left" }, "DELETE FILE", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "Are you sure you want to delete this file?", -1))
const _hoisted_18 = { class: "left" }

export function render(_ctx, _cache) {
  const _component_FileDragAndDrop = _resolveComponent("FileDragAndDrop")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_FilePreview = _resolveComponent("FilePreview")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _hoisted_2
      ]),
      body: _withCtx(() => [
        (_ctx.appName === 'TA')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_FileDragAndDrop, {
                disabled: _ctx.readOnly,
                ref: "fileDropAndDrop",
                numFileLimit: 5,
                onFileInputChanged: _ctx.uploadAllFiles,
                fileSizeLimit: 100,
                acceptAnyFileTypes: _ctx.acceptAnyFileTypes
              }, null, 8, ["disabled", "onFileInputChanged", "acceptAnyFileTypes"]),
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (f) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", {
                  class: "file-item",
                  style: {"max-width":"300px","overflow":"hidden"},
                  title: f?.fileName
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(f?.fileName), 1)
                ], 8, _hoisted_7),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$formatDateTimeTypeD(f?.createdOn)), 1),
                _createElementVNode("td", _hoisted_10, [
                  (_ctx.isSuperAdmin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-tertiary sml ml-1 mr-2",
                        disabled: _ctx.readOnly,
                        onClick: _withModifiers($event => (_ctx.deleteFile(f)), ["prevent","stop"])
                      }, " Delete ", 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-tertiary sml ml-1",
                    disabled: _ctx.readOnly,
                    onClick: _withModifiers($event => (_ctx.getFileStream(f)), ["prevent","stop"]),
                    style: {"width":"6rem"}
                  }, _toDisplayString(_ctx.getViewButtonLabel(f)), 9, _hoisted_12)
                ])
              ]))
            }), 256)),
            (_ctx.files.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                        _createVNode(_component_LoadingIndicator, {
                          class: "loading-indicator",
                          showLoadingText: false
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_15, "No Records"))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.isLoadingStream)
          ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
              key: 1,
              class: "loading-indicator",
              showLoadingText: false
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_FilePreview, {
      showPreview: _ctx.showFilePreview,
      previewFile: _ctx.selectedFileForPreview,
      state: _ctx.filePreviewState,
      disableBackgroundScroll: true,
      onCloseFilePreview: _cache[1] || (_cache[1] = $event => (_ctx.closeFilePreview()))
    }, null, 8, ["showPreview", "previewFile", "state"]),
    (_ctx.showDeleteConfirmation)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = $event => (_ctx.showDeleteConfirmation = false))
        }, {
          header: _withCtx(() => [
            _hoisted_16
          ]),
          body: _withCtx(() => [
            _hoisted_17
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "btn btn-secondary sml",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.deleteIt()))
              }, "Yes"),
              _createElementVNode("button", {
                class: "btn btn-tertiary sml",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.showDeleteConfirmation = false))
              }, "No")
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}